<script lang="ts" setup="">
import type { IconDefinition } from '@fortawesome/fontawesome-common-types'
import type { IconSize } from '~/utils/icon'
import type { SocialProvider } from '~/constants/social'
import { faFacebookF, faInstagram, faLinkedinIn } from '@fortawesome/free-brands-svg-icons'

defineProps<{
  href?: string
  provider: SocialProvider
  label?: string
  size?: IconSize
}>()

const mapping = {
  facebook: {
    href: FACEBOOK_URL,
    icon: faFacebookF,
  },
  instagram: {
    href: INSTAGRAM_URL,
    icon: faInstagram,
  },
  linkedin: {
    href: LINKEDIN_URL,
    icon: faLinkedinIn,
  },
} as const satisfies Record<SocialProvider, {
  icon: IconDefinition
} & ({
  href: string
  onClick?: never
} | {
  href?: never
  onClick: () => void
})>
</script>

<template>
  <a
    :href="href || mapping[provider].href"
    :aria-label="label || `Lenke til Juridikas ${provider}-side`"
    target="_blank"
    class="no-underline flex items-center p-[0.3rem] leading-none hover:contrast-75"
  >
    <Icon :icon="mapping[provider].icon" :size="size" />
  </a>
</template>
